import { z } from "zod";
import { userSchema } from "@common/schemas/user.schema";

export const organizationClientUsersQuerySchema = z.object({
    clientWorkspaceIds: z.array(z.string().uuid()).optional(),
});

export type OrganizationClientUsersQuery = z.infer<
    typeof organizationClientUsersQuerySchema
>;

export const organizationClientUserSchema = userSchema.pick({
    id: true,
    name: true,
    email: true,
    iconColor: true,
    avatar: true,
});

export type OrganizationClientUser = z.infer<
    typeof organizationClientUserSchema
>;
